import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CardBackground from "../../../../components/MainTemplate/CardBackground";
import { Bar, Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";
import {
  UserGroupIcon,
  ClockIcon,
  CalendarIcon,
  CheckCircleIcon,
  PencilIcon,
} from "@heroicons/react/24/solid";

import Modal from "../../../../components/Modal/Modal";

import TotalEnrolledFamiliesComponent from "./TotalEnrolledFamiliesComponent";
import UpcomingEvents from "./UpcomingEvents";
import FinancialDataComponent from "./FinancialDataComponent";
import UpcomingBirthdayComponent from "./UpcomingBirthdayComponent";
import CategorizingFamilyComponent from "./CategorizingFamilyComponent";
import TaskmanagerAddModal from "./TaskmanagerAddModal";
import TaskmanagerListComponent from "./TaskmanagerListComponent";
import RecentPostComponent from "./RecentPostComponent";
ChartJS.register(...registerables);

const DashboardChurchAdminChild = () => {
  const navigate = useNavigate();
  const [addTaskModal, setAddTaskModal] = useState(false);
  const refreshTaskListRef = useRef(null);

  const setRefreshTaskList = useCallback((fn) => {
    refreshTaskListRef.current = fn;
  }, []);

  const handleTaskRefresh = useCallback(() => {
    if (refreshTaskListRef.current) {
      refreshTaskListRef.current();
    }
  }, []);

  const toggleAddTaskModal = useCallback(() => {
    setAddTaskModal((prev) => !prev);
  }, []);

  return (
    <CardBackground>
      {addTaskModal && (
        <Modal onClose={toggleAddTaskModal}>
          <h2 className="mb-4 text-xl font-bold">Add Task</h2>
          <TaskmanagerAddModal
            setAddTaskModal={setAddTaskModal}
            refreshTaskList={handleTaskRefresh}
          />
        </Modal>
      )}
      {/* <TaskmanagerListComponent
        toggleAddTaskModal={toggleAddTaskModal}
        setRefreshTaskList={setRefreshTaskList}
      /> */}
      <div className="p-6 space-y-6">
        <h1 className="text-3xl font-bold text-gray-800">Dashboard</h1>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {/* Stat Cards */}
          <div className="flex items-center p-6 space-x-4 bg-white rounded-lg shadow">
            <UserGroupIcon className="w-12 h-12 text-blue-500" />

            <div className="">
              <TotalEnrolledFamiliesComponent />
            </div>
          </div>
          <div className="flex items-center p-6 space-x-4 bg-white rounded-lg shadow">
            <ClockIcon className="w-12 h-12 text-yellow-500" />
            <div>
              <div className="text-sm font-medium text-gray-500">
                Pending Confirmations
              </div>
              <div className="text-2xl font-semibold text-gray-800">15</div>
              <div className="flex items-center text-sm text-red-500">
                <svg
                  className="w-4 h-4 mr-1"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                3 less than yesterday
              </div>
            </div>
          </div>

          {/* Upcoming Events Card */}
          <div className="p-6 bg-white rounded-lg shadow">
            {/* <h2 className="mb-4 text-xl font-semibold text-gray-800">
              Upcoming Events
            </h2> */}

            <UpcomingEvents />
          </div>

          {/* Monthly Collections and Expenses Chart */}
          <div className="col-span-1 p-6 bg-white rounded-lg shadow md:col-span-2">
            {/* <h2 className="mb-4 text-xl font-semibold text-gray-800">
              Monthly Collections and Expenses
            </h2> */}
            <div className="h-64 md:h-80">
              <FinancialDataComponent />
              {/* <Bar data={financialData} options={financialOptions} /> */}
            </div>
          </div>

          {/* Attendance Chart */}
          <div className="p-6 bg-white rounded-lg shadow">
            {/* <h2 className="mb-4 text-xl font-semibold text-gray-800">
              Attendance Breakdown
            </h2> */}
            <div className="h-64">
              <CategorizingFamilyComponent />
              {/* <Doughnut data={attendanceData} options={attendanceOptions} /> */}
            </div>
          </div>

          {/* Upcoming Birthdays Card */}
          <div className="p-6 bg-white rounded-lg shadow">
            <h2 className="mb-4 text-xl font-semibold text-gray-800">
              Upcoming Birthdays
            </h2>

            <UpcomingBirthdayComponent />

            {/* <ul className="space-y-4">
              {[
                { day: "16", month: "May", name: "John Doe", age: "35" },
                { day: "19", month: "May", name: "Jane Smith", age: "28" },
                { day: "22", month: "May", name: "Mike Johnson", age: "42" },
              ].map((birthday, index) => (
                <li key={index} className="flex items-center space-x-4">
                  <div className="flex-shrink-0 p-2 text-center bg-pink-100 rounded-lg">
                    <div className="text-sm font-semibold text-pink-800">
                      {birthday.day}
                    </div>
                    <div className="text-xs text-pink-600">
                      {birthday.month}
                    </div>
                  </div>
                  <div>
                    <div className="font-medium text-gray-800">
                      {birthday.name}
                    </div>
                    <div className="text-sm text-gray-500">
                      Turning {birthday.age}
                    </div>
                  </div>
                </li>
              ))}
            </ul> */}
          </div>

          {/* Pending Tasks Card */}
          <div className="p-3 rounded-lg shadow bg-gray-50">
            <h2 className="mb-4 text-xl font-semibold text-gray-800">
              Pending Tasks
            </h2>
            <TaskmanagerListComponent
              toggleAddTaskModal={toggleAddTaskModal}
              setRefreshTaskList={setRefreshTaskList}
            />
          </div>

          {/* User Posts Card */}
          <div className="p-6 bg-white rounded-lg shadow">
            <h2 className="mb-4 text-xl font-semibold text-gray-800">
              My Recent Posts
            </h2>
            <RecentPostComponent />
          </div>
        </div>
      </div>
    </CardBackground>
  );
};

export default DashboardChurchAdminChild;
